import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import Table from "react-bootstrap/Table";
import { sortLoanHistory, loanEventMessage,
  base_url,
  LOAN_CURRENCY_TYPE_BHD,
  LOAN_CURRENCY_TYPE_USD,
  LOAN_REPAYMENT_BY_BUSINESS,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  STATUS_CLOSED,
} from "../utilities";
import axios from ".././axios-interceptor";
import { toast } from "react-toastify";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import Cookies from 'js-cookie';
import {
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
} from "../utilities";
import { Form } from "react-bootstrap";
window.Buffer = window.Buffer || require("buffer").Buffer;

const AdminPrePaymentRequest = (props) => {
  const [loading, setLoading] = useState(true);
  const [returnPayments, setReturnPayements] = useState([]);
  const [returnPaymentsFilter, setReturnPayementsFilter] = useState([]);
  let returnPay = props.data.return_payments;
  useEffect(() => {
    if (props.data !== "" || props.data !== undefined) {
      setLoading(false);
    }
    if (returnPay !== undefined) {
      setReturnPayements(returnPay);
      setReturnPayementsFilter(returnPay);
    }
  }, [returnPay]);

  const titles = [
    { title: "Investment Payment", field: "tenure_amount" },
    { title: "Tenure Date", field: "tenure_date" },
    { title: "Amount Repaid", field: "paid_amount" },
  ];
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });
    const sortedData = [...returnPayments].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setReturnPayementsFilter(sortedData);
  };

  const [activeTab, setActiveTab] = useState("home-tab");
  const [assignee, setAssignee] = useState("");
  const [adminnotes, setAdminNotes] = useState("");
  const [show, setShow] = useState(false);
  let loan_history_array = [];
  const handleShowReject = () => setShow(true);
  const [prepaymentDate, setDate] = useState(null);

  useEffect(() => {
    if (props.data?.partial_prepayment_date) {
      setDate(new Date(props.data?.partial_prepayment_date));
    }
  }, [props.data.partial_prepayment_date]);

  let download;
  if (props.data.documents === undefined) {
    download = [];
  } else {
    download = props.data.documents;
  }
  let user = Cookies.get("admin_user_name");
  if (props.data.loan_history != undefined) {
    props.data.loan_history.map(each_history_record => {
      // D8: records with their own description are shown as-is (generic events, waivers, closure).
      if (each_history_record.description) {
        loan_history_array.push({ message: loanEventMessage(each_history_record, { admin: true }), created_date_time: each_history_record.created_date_time });
        return;
      }
      //NEW LOAN REQUEST LIST
      if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = "Business requested loan";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if((!each_history_record.is_investor_interested) && (!each_history_record.is_admin_sent_terms_to_business)){
      if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = "Admin filled the profit percentage and sent to investors";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
    }
      if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = "Admin rejected the new loan request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_investor_interested===1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = "Investor has shown interest on this loan";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_admin_sent_terms_to_business===1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = "Admin sent loan terms and awaiting for business response";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }

      if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = "Business agreed the new loan request terms";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }

      if (each_history_record.status == STATUS_PROCESSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = (
          <div className='style_loan_txt'>
            Admin paid the requested loan amount <span style={{color:"black",marginTop:"2px" }} className="ps-1 pe-1 fw-bold">{each_history_record.paid_currency +" "+ Number(each_history_record.paid_amount).toLocaleString() }</span> to business on <span style={{color:"black",marginTop:"2px"}} className="ps-1 pe-1 fw-bold">{ moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
          </div>
        );
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if (each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = 
        <div className=''>
        Business repaid for the month of <span style={{color:"black"}} className="fw-bold">{moment(each_history_record.tenure_date).format('MMMM')}</span>, loan tenure amount <span style={{color:"black"}} className="fw-bold">{ each_history_record.paid_currency +" "+ Number(each_history_record.paid_amount).toLocaleString()}</span> to admin on <span style={{color:"black"}} className=" fw-bold">{moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
      </div>
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }

 
      if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
        let message = "Business requested to extend loan tenure";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
        let message = "Admin approved extend tenure request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }


      if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
        let message = "Admin rejected the extend tenure request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }


      if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
        let message = "Business requested for pre closure of a loan";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
        let message = "Admin approved pre closure request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
        let message = "Admin rejected pre closure request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT) {
        let message = "Business requested for partial prepayment of a loan";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT) {
        let message = "Admin approved partial prepayment request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT) {
        let message = "Admin rejected partial prepayment request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
      if (
        each_history_record.status == STATUS_NEW &&
        each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
      ) {
        let message = "Business requested for partial pre-payment of a loan";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_APPROVED &&
        each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
      ) {
        let message = "Admin approved partial pre-payment request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_REJECTED &&
        each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
      ) {
        let message = "Admin rejected partial pre-payment request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (each_history_record.status == STATUS_CLOSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = "Business repaid the loan successfully"
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
    })
  }
  useEffect(() => { }, []);
  let months = [];
  for (let i = 1; i <= 48; i++) {
    if (i % 1 === 0) {
      months.push(i);
    }
  }
  const handleClose = () => {
    props.onHide();
    setActiveTab("home-tab");
  };
//   const closeButton = () => {
//     props.onHide();
//   };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleCloseRejectClose = () => {
    setShow(false);
  };
  const handleCloseReject = () => {
    //hit the api from rejection api here
    let service_request_id = {
      service_request_id: props.data.service_request_id,
      assignee: assignee == "" ? Cookies.get("admin_user_name") : assignee,
      admin_user_id:Cookies.get("admin_user_id"),
      admin_notes: adminnotes,
    };
    axios
      .post(
        base_url + "service-request-trx/reject_partial_prepayment_request",
        service_request_id
      )
      .then((res) => {
        if (res.data.status == 200) {
          setShow(false);
          toast.success("Rejected Successfully", {
            toastId: 4,
          });
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };
  const [activeTabBool, setActiveTabBool] = useState(false);
  const handleSavechanges = (data) => {
    let service_request_id = 
    {
        "service_request_id":props.data.service_request_id,
        "loan_id":props.data.loan_id,
        "partial_prepayment_date": new Date(prepaymentDate).getTime(),
        "partial_prepayment_amount": props.data.partial_prepayment_amount,
        "assignee" :assignee === "" ? Cookies.get("admin_user_name") : assignee,
    };
    setActiveTabBool(true);
    axios
      .post(
        base_url + "service-request-trx/approve_partial_prepayment_request",
        service_request_id
      )
      .then((res) => {
        if (res.data.status === 200) {
          setShow(false);
          toast.success("Approved Successfully", {
            toastId: 4,
          });
          props.onHide();

          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };
  const handleChangeInput = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    if (name === "assignee") {
      setAssignee(value);
    }
    if (name === "admin_notes") {
      setAdminNotes(value);
    }
  };

  const handleDownload = async (url, document_type) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = props.data.business_name+"_"+document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err)
    }
  };
  return (
    <>
      <Modal
        {...props}
        dialogClassName="modal-190w"
        aria-labelledby="example-custom-modal-styling-title"
        size="xl"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header onHide={handleClose} closeButton className="modal_title">
          <Modal.Title id="example-custom-modal-styling-title">
            <div className="heading_new_loan  ps-2">Partial Pre-payment Request</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-2 admin_all_preclosure_body">
          <div className="row ">
            <div className="col-8">
              <div className="row mb-3">
                <div className="col-4">
                  <p className="text_st">Business Name</p>
                  <span className="text_bolder">
                    {" "}
                    {props.data.business_name === undefined ? '-' : props.data.business_name}
                  </span>
                </div>
                <div className="col-4">
                  <p className="text_st">Loan Reference No.</p>
                  <span className="bolder_text">
                    {props.data.loan_reference_number === undefined ? '-' : props.data.loan_reference_number}
                  </span>
                </div>
                <div className="col-4">
                  <p className="text_st">Loan Type</p>
                  <span className="bolder_text">
                    {props.data.loan_type_name === undefined ? '-' : props.data.loan_type_name}
                  </span>
                </div>
              </div>
              <div className="row mt-2 mb-3">
                <div className="col-4">
                  <p className="text_st">Requested Tenure </p>
                  <span className="bolder_text">
                    {props.data.loan_tenure}{" "}
                    {props.data.loan_tenure == 1 ? " Month" : " Months"}
                  </span>
                </div>
                <div className="col-4">
                  <p className="text_st">Loan Amount</p>
                  <span className="bolder_text">
                    {props.data.loan_currency == LOAN_CURRENCY_TYPE_USD
                      ? "$"
                      : LOAN_CURRENCY_TYPE_BHD}{"\u00A0"}
                    {Number(props.data.loan_amount).toLocaleString()}
                  </span>
                </div>
               
              </div>
              <div className="row mb-1">
                <div className="col">
                  <p className="text_st"> Reason For Partial Pre-payment</p>
                  <div className="bolder_text "> {props.data.notes ===''|| props.data.notes===undefined ? '-':props.data.notes}</div>
                </div>
              </div>
            </div>
            <div className="col-4">
              {download.map((item) => {
                return (
                  <div key={item.doc_type} className="row  ps-4">
                    <div className="col-9">
                      <article className="text_bolde_doc ">
                        {item.document_type}{" "}
                      </article>
                    </div>
                    <div className="col d-flex justify-content-center">
                      <span className="">
                        {" "}
                        <a
                          style={{ display: "table-cell" }}
                          href={item.document_url}
                          target="_blank"
                        >
                          <img src="./images/eye.svg" alt="" />
                        </a>
                      </span>
                      <span
                        className="Cpointer ps-3"
                        onClick={() =>
                          handleDownload(item.document_url, item.document_type)
                        }
                      >
                        <img src="./images/down.svg" alt="" />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <hr />
          <div className="row d-flex gap-4">
            <div className="col">
              {" "}
              <div className="row bg-white">
                <div className="col">
                  <ul
                    className="nav nav-tabs d-flex"
                    id="myTab"
                    role="tablist"
                    style={{ height: "50px" }}
                  >
                    <li className="nav-item " role="presentation">
                      <button
                        className="nav-link active ps-0 "
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="true"
                        onClick={() => setActiveTab("home-tab")}
                      >
                        <h6>Schedule Of Return Payments</h6>
                        {activeTab === "home-tab" && (
                          <img
                            style={{ marginTop: "-48px" }}
                            src="./images/polygondown.svg"
                            alt=""
                          />
                        )}
                      </button>
                    </li>
                    <li className="nav-item " role="presentation">
                      <button
                        className="nav-link "
                        id="profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#profile-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="profile-tab-pane"
                        aria-selected="false"
                        onClick={() => setActiveTab("profile-tab")}
                      >
                        <h6>Loan History</h6>
                        {activeTab === "profile-tab" && (
                          <img
                            style={{ marginTop: "-48px" }}
                            src="./images/polygondown.svg"
                            alt=""
                          />
                        )}
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active preclosure_Table_body"
                    id="home-tab-pane"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                    tabIndex="0"
                  >
                    <Table striped bordered hover>
                      <thead className="all_inv_table_head">
                        <tr>
                          {titles.map((column) => (
                            <th
                              key={column.field}
                              onClick={() => handleSort(column.field)}
                            >
                              {column.title}
                              &#9662;
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {returnPaymentsFilter?.map((data, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {loading ? (
                                  <Skeleton width={100} height={15} />
                                ) : data.admin_request_loan_currency ===
                                  LOAN_CURRENCY_TYPE_BHD ? (
                                  "BHD " +
                                  Number(data.tenure_amount).toLocaleString()
                                ) : (
                                  "$\u00A0"
                                  +
                                  Number(data.tenure_amount).toLocaleString())
                                }
                              </td>
                              <td>
                                {loading ? (
                                  <Skeleton width={100} height={15} />
                                ) : (
                                  moment(data.tenure_date).format("DD MMM YYYY")
                                )}
                              </td>
                              <td>
                                {loading ? (
                                  <Skeleton width={100} height={15} />
                                ) : data.admin_request_loan_currency ===
                                  LOAN_CURRENCY_TYPE_BHD ? (
                                  "BHD " +
                                  Number(data.paid_amount).toLocaleString()
                                ) : (
                                  "$\u00A0" +
                                  Number(data.paid_amount).toLocaleString())
                                }
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <div
                    className="tab-pane fade loan_history_tab"
                    id="profile-tab-pane"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                    tabIndex="0"
                  >
                    <div className="row gap-3 ps-3" style={{ height: "25vh" }}>
                      {sortLoanHistory(loan_history_array).map((details) => {
                        return (
                          <div
                            key={details.message}
                            className="row pt-0 lh_custom_style"
                          >
                            <div className="style_loan">
                              <img
                                className="me-2"
                                src="./images/circle.svg"
                                alt=""
                                srcSet=""
                                height={16}
                                width={16}
                              />
                              {moment(details.created_date_time).format(
                                "ddd, D MMM YYYY, h:mm A"
                              )}
                            </div>
                            <div className="style_loan_txt mb-4 ms-4 pe-5">
                          {details.message}
                        </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
           
            <div className="col-5">
              <div className="ten_text mt-4 ps-3">
                Partial Prepayment Date Requested
              </div>

              
              <div className="bolder_text mt-1 ps-3">
                {" "}
                {prepaymentDate && (
                  <input
                    type="date"
                    id="dateInput"
                    name="date"
                    defaultValue={prepaymentDate.toISOString().substr(0, 10)}
                    onChange={(event) => setDate(new Date(event.target.value))}
                  />
                )}
              </div>
              <div className="col bolder_text my-3 ps-3">
                  <p className="ten_text">Partial Pre-payment Amount</p>
                  <span className="bolder_text">
                    {props.data.loan_currency == LOAN_CURRENCY_TYPE_USD
                      ? "$"
                      : LOAN_CURRENCY_TYPE_BHD}{"\u00A0"}
                    {Number(props.data.partial_prepayment_amount).toLocaleString()}
                  </span>
                </div>
              <div className="mt-2 ps-3">
                <Form.Group
                  className=" "
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label className="reason_text mb-0 ">Reason</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder=""
                    id="admin_notes"
                    name="admin_notes"
                    onChange={handleChangeInput}
                  // {props.data.notes}
                  />
                </Form.Group>
              </div>
            </div>

            
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between ps-3 pe-3">
          <div>
            <label htmlFor="Assignee">
              <p className="ms-2">Assignee</p>
            </label>
            <select
              id="assignee"
              name="assignee"
              className="form-select shadow-ben"
              aria-label="form-select example"
              onChange={handleChangeInput}
            >
              {/* <option value="">Assignee</option> */}
              <option value={user}>{user}</option>
            </select>
          </div>
          <div className="admin_footer_buttons">
            <button
              className="gray_btn btn mx-2 px-3 py-2"
              variant="secondary"
              onClick={handleClose}
            >
              Close
            </button>

            <button
              className="btn mx-2 py-2 px-3"
              style={{ backgroundColor: "#ED5151", color: "white" }}
              variant="secondary"
              onClick={handleShowReject}
            >
              Reject
            </button>
            <button
              className="btn blue_btn ms-2 py-2"
              variant="primary"
              disabled={activeTabBool}
              onClick={handleSubmit(handleSavechanges)}
            >
              Approve Partial Prepayment
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleCloseRejectClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body className="alert_modal">
          Are you sure you want to reject?
        </Modal.Body>
        <div className="p-2 d-flex justify-content-end gap-3">
          <button
            className="btn px-3"
            style={{ backgroundColor: "grey", color: "white" }}
            variant="primary"
            onClick={handleCloseRejectClose}
          >
            Cancel
          </button>
          <button
            className="btn px-4"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            variant="danger"
            onClick={handleCloseReject}
          >
            Yes
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AdminPrePaymentRequest;
